import { Component, signal, inject, Output, EventEmitter } from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import { MatAnchor } from "@angular/material/button";
import {merge} from 'rxjs';
import { PlaylistService } from '../../services/playlist.service';



@Component({
  selector: 'app-addplaylist',
  imports: [MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatAnchor],
  templateUrl: './addplaylist.component.html',
  styleUrl: './addplaylist.component.css',
})
export class AddplaylistComponent {
  @Output() refresh = new EventEmitter<void>();

  placeholderUrl = "https://www.youtube.com/playlist?list=";
  readonly url = new FormControl('', [Validators.required]); // Input field declarati

  errorMessage = signal('');
  private playlistService = inject(PlaylistService);

  constructor() {
    merge(this.url.statusChanges, this.url.valueChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateErrorMessage());
  }

  updateErrorMessage() {
    if (this.url.hasError('required')) {
      this.errorMessage.set('You must enter a value');
    } else {
      this.errorMessage.set('');
    }
  }

  public addPlaylist(){
    console.log(this.url)
    const id = this.url.value?.replace(this.placeholderUrl,"");

    if(id !== undefined){
      this.playlistService.addPlaylist(id);

      this.playlistService.addPlaylist(id).subscribe({
        next: (data: []) => {
          console.log('Playlists added successfully');
          this.refresh.emit();
        },
        error: (error: any) => {
          console.error('Failed to fetch playlists:', error);
        }
      });

    }

  }

}
